import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import type { ComponentPropsWithoutRef } from 'react';

import type { IconProp } from '@fortawesome/fontawesome-svg-core';

type IconType = 'fab' | 'fad' | 'fajd' | 'fajf' | 'fajr' | 'far' | 'fas' | 'fawsb';

type IconProps = Omit<ComponentPropsWithoutRef<typeof FontAwesomeIcon>, 'icon'> & {
	type?: IconType;
	icon: string;
};

type IconValue =
	| string
	| {
			icon: string;
			type?: IconType;
	  };

const resolveIcon = (value: IconValue, defaultType: IconType = 'far'): Pick<IconProps, 'icon' | 'type'> => ({
	icon: typeof value === 'string' ? value : value.icon,
	type: typeof value === 'string' ? defaultType : value.type || defaultType,
});

function Icon({ type = 'far', icon, className, ...props }: IconProps) {
	return <FontAwesomeIcon icon={[type, icon] as unknown as IconProp} {...props} className={className} />;
}

const createIcon = (type: IconProps['type']) => (props: Omit<IconProps, 'type'>) => <Icon type={type} {...props} />;

const FabIcon = createIcon('fab');
const FadIcon = createIcon('fad');
const FajdIcon = createIcon('fajd');
const FajfIcon = createIcon('fajf');
const FajrIcon = createIcon('fajr');
const FarIcon = createIcon('far');
const FasIcon = createIcon('fas');
const FawsbIcon = createIcon('fawsb');

export { FabIcon, FadIcon, FajdIcon, FajfIcon, FajrIcon, FarIcon, FasIcon, FawsbIcon, Icon, resolveIcon };
export type { IconProps, IconValue };
